export default __webpack_public_path__ + "static/media/vip-ico.66951ea0.svg";